import { render, staticRenderFns } from "./Activation.vue?vue&type=template&id=a2bc2544&scoped=true"
import script from "./Activation.vue?vue&type=script&lang=js"
export * from "./Activation.vue?vue&type=script&lang=js"
import style0 from "./Activation.vue?vue&type=style&index=0&id=a2bc2544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bc2544",
  null
  
)

export default component.exports